import { render, staticRenderFns } from "./TeProducts.vue?vue&type=template&id=3199e809&scoped=true"
import script from "./TeProducts.vue?vue&type=script&lang=js"
export * from "./TeProducts.vue?vue&type=script&lang=js"
import style0 from "./TeProducts.vue?vue&type=style&index=0&id=3199e809&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3199e809",
  null
  
)

export default component.exports